import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const Coupon = () => {
  const [coupons, setCoupons] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const returnTo = location.state?.returnTo;
  const product = location.state?.product;
  const cartIds = location.state?.cartIds || [];
  const orderType = location.state?.orderType;

  const reserveYn = location.state?.reserveYn;
  const pickupDate = location.state?.pickupDate;
  const pickupTime = location.state?.pickupTime;
  const pickupDatetime = location.state?.pickupDatetime;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
  
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
  };

  // 주문 소계 금액 받아오기
  const currentSubtotal = location.state?.subtotal || 0;

  const isOrderFlow = Boolean(returnTo && currentSubtotal > 0);

  const getStatus = (coupon) => {
    if (coupon.used_yn === 'Y') {
      return { text: '사용완료', color: '#999', disabled: true };
    }
  
    if (coupon.active === 0) {
      return { text: '사용불가', color: '#999', disabled: true };
    }
  
    if (new Date(coupon.end_date) < new Date()) {
      return { text: '기간만료', color: '#999', disabled: true };
    }
  
    if (isOrderFlow && currentSubtotal < coupon.min_order_price) {
      return {
        text: '최소금액 미충족',
        color: '#dc3545',
        disabled: false
      };
    }
  
    return {
      text: '사용가능',
      color: '#28a745',
      disabled: false
    };
  };
  
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const url = returnTo
          ? `/api/coupon/available?subtotal=${currentSubtotal}`
          : '/api/coupon';
  
        const res = await axios.get(url, { withCredentials: true });
  
        setCoupons(res.data.coupons || []);
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchCoupons();
  }, [returnTo, currentSubtotal]);

  const handleSelectCoupon = (coupon) => {
    if (!returnTo) return;
  
    if (currentSubtotal < coupon.min_order_price) {
      alert(
        `이 쿠폰은 ${Number(coupon.min_order_price).toLocaleString()}원 이상 주문 시 사용 가능합니다.`
      );
      return;
    }
  
    const params = new URLSearchParams();
  
    if (returnTo === '/order/now' && product?.id) {
      params.set('product_id', product.id);
      params.set('quantity', product.quantity || 1);
    }
  
    if (returnTo === '/order/selected' && cartIds.length > 0) {
      params.set('cart_ids', cartIds.join(','));
    }
  
    if (reserveYn) params.set('reserve_yn', reserveYn);
    if (pickupDate) params.set('pickup_date', pickupDate);
    if (pickupTime) params.set('pickup_time', pickupTime);
    if (pickupDatetime) params.set('pickup_datetime', pickupDatetime);
  
    navigate(`${returnTo}?${params.toString()}`, {
      state: {
        product,
        cartIds,
        orderType,
        selectedCouponId: coupon.member_coupon_id,
  
        reserveYn,
        pickupDate,
        pickupTime,
        pickupDatetime
      }
    });
  };

  const handleNoCoupon = () => {
    if (!returnTo) return;
  
    const params = new URLSearchParams();
  
    if (returnTo === '/order/now' && product?.id) {
      params.set('product_id', product.id);
      params.set('quantity', product.quantity || 1);
    }
  
    if (returnTo === '/order/selected' && cartIds.length > 0) {
      params.set('cart_ids', cartIds.join(','));
    }
  
    if (reserveYn) params.set('reserve_yn', reserveYn);
    if (pickupDate) params.set('pickup_date', pickupDate);
    if (pickupTime) params.set('pickup_time', pickupTime);
    if (pickupDatetime) params.set('pickup_datetime', pickupDatetime);
  
    navigate(`${returnTo}?${params.toString()}`, {
      state: {
        product,
        cartIds,
        orderType,
        selectedCouponId: null,
  
        reserveYn,
        pickupDate,
        pickupTime,
        pickupDatetime
      }
    });
  };

  const getDiscountText = (coupon) => {
    if (coupon.discount_type === 'amount') {
      return `${coupon.discount_value.toLocaleString()}원 할인`;
    }
    return `${coupon.discount_value}% 할인`;
  };

  return (
    <div className="container mt-3" style={styles.container}>
      <h3 style={styles.title}>내 쿠폰</h3>

      {returnTo && (
        <div style={styles.card} onClick={handleNoCoupon}>
          <div style={styles.name}>쿠폰 사용 안함</div>
          <div style={styles.info}>할인을 적용하지 않습니다.</div>
        </div>
      )}

      {coupons.length === 0 ? (
        <div style={styles.empty}>보유한 쿠폰이 없습니다.</div>
      ) : (
        coupons.map((coupon) => {
          const status = getStatus(coupon);

          return (
            <div
              key={coupon.member_coupon_id}
              style={{
                ...styles.card,
                opacity: status.disabled ? 0.5 : 1,
                cursor: status.disabled
                  ? 'default'
                  : (returnTo ? 'pointer' : 'default')
              }}
              onClick={() => {
                if (!status.disabled && returnTo) {
                  handleSelectCoupon(coupon);
                }
              }}
            >
              <div style={styles.header}>
                <div style={styles.name}>{coupon.coupon_name}</div>
                <span
                  style={{
                    ...styles.badge,
                    color: status.color,
                    borderColor: status.color
                  }}
                >
                  {status.text}
                </span>
              </div>

              <div style={styles.discount}>{getDiscountText(coupon)}</div>
              <div style={styles.info}>
                최소 주문금액 {Number(coupon.min_order_price).toLocaleString()}원
              </div>
              <div style={styles.info}>
                사용기간 : {formatDate(coupon.start_date)} ~ {formatDate(coupon.end_date)}
              </div>
              {coupon.used_yn === 'Y' && coupon.used_at && (
              <>
                
                <div style={styles.info}>
                  사용완료 : {formatDate(coupon.used_at)}
                </div>
              </>
            )}
            </div>
          );
        })
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '20px auto 40px',
    fontFamily: 'sans-serif'
  },
  title: {
    fontWeight: '700',
    marginBottom: '20px'
  },
  empty: {
    textAlign: 'center',
    padding: '40px',
    color: '#999'
  },
  card: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '18px',
    marginBottom: '18px',
    background: '#fff'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  name: {
    fontWeight: '700',
    fontSize: '18px'
  },
  badge: {
    border: '1px solid',
    borderRadius: '20px',
    padding: '4px 10px',
    fontSize: '12px',
    fontWeight: '600'
  },
  discount: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#0073e9',
    marginTop: '15px',
    marginBottom: '15px'
  },
  info: {
    fontSize: '12px',
    color: '#666',
    lineHeight: '1.7'
  }
};

export default Coupon;